import script from "./MessageTimestamp.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageTimestamp.vue?vue&type=script&setup=true&lang=js"

import "./MessageTimestamp.vue?vue&type=style&index=0&id=c8f792ae&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8f792ae"]])

export default __exports__